import Image from 'next/image';
import React from 'react';

import type { ManageSIPPropsType } from '@/types/manageSip';
import {
  getCycleName,
  getDayByDate,
  getFormattedDate,
  getSipFrequency,
  getSipImage,
  sipStatusEnums,
} from '@/utils/functions/SIPs';

export const ManageSIPWebItem = (props: ManageSIPPropsType) => {
  const { each, onClickSetSIPSummary } = props;

  return (
    <>
      <tbody
        className="border-top-1"
        // style={{ borderTop: '1px' }}
      >
        <tr>
          <td className="text--semi text--black manage-sip-row-name-amount">
            {getCycleName(each?.paymentCycle)} SIP
          </td>
          <td className="text--semi text--black manage-sip-row-name-amount">
            ₹{each?.amount}
          </td>
          <td className="text--black manage-sip-row-info">
            {/* {each?.lastDeductionDate} */}
            {getFormattedDate(each?.lastDeductionDate)}
          </td>
          <td className="text--black manage-sip-row-info">
            {/* {getCycleName(each?.paymentCycle)} on{' '}
            {getDayByDate(each?.startDate, each?.paymentCycle)} */}
            {getSipFrequency(each?.paymentCycle)}{' '}
            {getDayByDate(each?.startDate, each?.paymentCycle)}
          </td>
          <td>
            <div className="nature text--black manage-sip-row-info">
              {each?.sipStatus ? (
                <Image
                  style={{ color: undefined }}
                  className="img-fluid"
                  src={getSipImage(each?.sipStatus)}
                  alt=""
                />
              ) : null}
              {each?.sipStatus ? sipStatusEnums[each?.sipStatus] : 'NA'}
            </div>
          </td>
          {/* <td>
          <div className="nature text--black">
            <img
              className="img-fluid"
              src="./assets/images/icons/upi-icon.png"
              alt="UPI icon"
            />{" "}
            UPI
          </div>
        </td> */}
          <td>
            <button
              type="button"
              onClick={() => onClickSetSIPSummary(each)}
              className="circleArrow-icon m-auto"
              // style={{ marginLeft: 'auto' }}
            >
              <span className="sr-only">detail</span>
            </button>
          </td>
        </tr>
      </tbody>
    </>
  );
};
